import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import AlertNotification from '@blade-sxp/task-management/components/alert-notification.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
import { isEmpty, cloneDeep } from 'lodash';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdNumber = class CrowdNumber extends Vue {
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    type = 'add';
    taskType = '';
    disableRight = false;
    id = '';
    notifData = {
        alarmConfig: {
            thresholdConfigs: [{ levelConfig: [] }],
            notifyConfig: { frequency: { value: '' }, enabledAlarmLevels: [] },
        },
    };
    isError = false;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    isReady = false;
    isCompinent = false;
    remark = '';
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, isCompinent, notifData } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            isCompinent,
            notifData,
        };
    }
    get getdeviceIdRequestParams() {
        return DeviceIdDataModule.deviceIdRequestParams;
    }
    get getCrrentRoi() {
        return DeviceIdDataModule.isMapData;
    }
    getCrrentRoiMap(val) {
        // 判断地图是否画完
        this.isCompinent = val;
    }
    async validForm(val) {
        if (this.isDetail) {
            return;
        }
        if (!this.isCompinent) {
            this.disableRight = true;
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        const isNotData = val?.notifData.alarmConfig?.notifyConfig?.frequency?.value; // 判断等级
        if (!isNotData) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
            DeviceIdDataModule?.updataMapData(false);
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            DeviceIdDataModule?.updataMapData(true);
            this.getData();
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    getData() {
        this.loading = true;
        Service.getTaskDetail(Number(this.id))
            .then((res) => {
            const { name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs, } = res;
            this.name = name;
            this.remark = remark;
            let obj = {
                alarmConfig: {
                    thresholdConfigs: [{ levelConfig: [] }],
                    notifyConfig: { frequency: { value: notifyConfig.frequency.value }, enabledAlarmLevels: notifyConfig.enabledAlarmLevels },
                },
            };
            this.notifData = obj;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, levelConfig } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                for (let key in levelConfig) {
                    if (levelConfig[key]) {
                        this.notifData.alarmConfig.thresholdConfigs[0].levelConfig[key] = String(levelConfig[key]);
                    }
                }
                if (!isEmpty(deviceTaskConfigs)) {
                    // const data = new Map();
                    deviceTaskConfigs?.forEach((item) => {
                        const roiData = item.roiData;
                        const { detectMode, enableAttributesAnalysis } = item?.regionStatisticConfig;
                        const modelType = detectMode;
                        const enableAttributes = enableAttributesAnalysis;
                        if (item.incidentType === 'INCIDENT_AREA' && !isEmpty(roiData)) {
                            const analysis = JSON.parse(roiData);
                            DeviceIdDataModule.markMapData.clear();
                            analysis.titleList.forEach((item) => {
                                if (item.type === 'MAP') {
                                    item?.data?.forEach((item) => {
                                        DeviceIdDataModule.markMapData.set(item.id, item);
                                    });
                                }
                                if (item.type === 'MODEL') {
                                    item.data = modelType;
                                    item.enableAttributesAnalysis = enableAttributes;
                                }
                            });
                            DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                        }
                    });
                }
                DeviceIdDataModule?.updataIsMapData(true);
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const params = {
            remark: this.remark,
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: this.notifData.alarmConfig.notifyConfig.enabledAlarmLevels,
                    frequency: {
                        unit: 'MINUTE',
                        value: this.notifData.alarmConfig.notifyConfig.frequency.value,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        levelConfig: {
                            critical: this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.critical,
                            major: this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.major,
                            minor: this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.minor,
                            unit: 'PERCENT',
                        },
                        threshold: {
                            type: 'COUNTING',
                            unit: 'MINUTE',
                            value: 0,
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        let requestMap = new Map();
        let zoneIdMap = '';
        let deviceIdMap = '';
        let rawRoi = [];
        let mapRoiData = [];
        let persons = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let modelType = '';
        let enableAttributesAnalysis = null;
        if (!isEmpty(device)) {
            requestMap = cloneDeep(device);
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                zoneIdMap = zoneId;
                deviceIdMap = deviceId;
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                        if (item.type === 'MAP') {
                            rawRoi.forEach((it, index) => {
                                const id = it.rawRoi.name;
                                if (item.data.length) {
                                    mapRoiData.push(item?.data[index]);
                                    it.twinRoi = { ...item?.data[index], name: id, id: this.taskId() };
                                }
                                else {
                                    const { vertices } = item?.data.get(id);
                                    vertices?.shift();
                                    mapRoiData.push(item?.data.get(id));
                                    it.twinRoi = { ...item?.data.get(id), name: id, id: this.taskId() };
                                }
                            });
                        }
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'MODEL') {
                            modelType = item.data;
                            enableAttributesAnalysis = item.enableAttributesAnalysis;
                        }
                    });
                }
            });
        }
        const { titleList } = device.get(deviceIdMap);
        if (titleList) {
            titleList[2].data = mapRoiData;
        }
        return [
            {
                deviceId: deviceIdMap,
                incidentType: 'INCIDENT_AREA',
                labelPersons: persons,
                // roiData: JSON.stringify({ roi: device.get(deviceIdMap), map: mapRoiData }),
                roiData: JSON.stringify(device.get(deviceIdMap)),
                zoneId: zoneIdMap,
                regionStatisticConfig: {
                    enableAttributesAnalysis: enableAttributesAnalysis,
                    roiMappings: rawRoi,
                    detectMode: modelType,
                },
            },
        ];
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    getThresholdData(val) {
        this.notifData.alarmConfig.notifyConfig.frequency.value = val.value;
        this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.major = val.major;
        this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.critical = val.critical;
        this.notifData.alarmConfig.thresholdConfigs[0].levelConfig.minor = val.minor;
        this.notifData.alarmConfig.notifyConfig.enabledAlarmLevels = val.enabledAlarmLevels;
    }
};
__decorate([
    Watch('getCrrentRoi', { deep: true, immediate: true })
], CrowdNumber.prototype, "getCrrentRoiMap", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdNumber.prototype, "validForm", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdNumber.prototype, "init", null);
CrowdNumber = __decorate([
    Component({
        name: 'CrowdCountingVa',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'button-box': ButtonBox,
            'st-device-darwer': DeviceDarwer,
            'alert-notification': AlertNotification,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    visitorTitle: 'Initial Visitor Number',
                },
                zh: {
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    visitorTitle: '初始人数',
                },
            },
        },
    })
], CrowdNumber);
export default CrowdNumber;
